import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ItemIdModel } from './../../../core/models/filter-model/item-id-model';
import { RegulatorMaster } from 'src/app/core/models/regulation/regulator-master';
import { UpdatePubType } from 'src/app/core/models/user-management/update-pub-type';
import { ToastViewModel } from './../../../core/models/view-model/toast-view-model';
import { RegulatorPubTypeModel } from 'src/app/core/models/user-management/pub-type-model';
import { DownloadReportModel } from './../../../core/models/view-model/download-report-model';
import { ParentChildItemModel } from 'src/app/core/models/filter-model/parent-child-item-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { CommonService } from './../../../core/services/common/common.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { MatAutocomplete } from '@angular/material/autocomplete';
@Component({
  selector: 'app-manage-pub-type',
  templateUrl: './manage-pub-type.component.html',
  styleUrls: ['./manage-pub-type.component.scss']
})
export class ManagePubTypeComponent implements OnInit {

  myInnerHeight: any;
  pubTypeList: RegulatorPubTypeModel;
  isLoading = false;
  isLoadingBar = false;
  searchText = '';
  searchRegulatorId = 0;

  searchRegText = '';
  isSelectAll = false;
  regulatorArray: Array<number>;
  pubArray: Array<string>;
  allRegulators: Array<RegulatorMaster>;
  regulators: Array<RegulatorMaster>;
  selectedJurisId = 0;
  selectedJurisIdForPubType = 0;
  jurisdictions: Array<ItemIdModel>;
  jurisRegulator: Array<ParentChildItemModel>;
  isLoader = false;
  isToastShow = false;
  toastModel: ToastViewModel;
  updatedPubType: Array<UpdatePubType>;
  isExportLoader: boolean = false;
  regulatorAutocompleteCntrl = new FormControl('');
  searchedRegulators:ParentChildItemModel[] = [];
  searchPubText = '';
  allPub:any;
  @ViewChild('input') input: ElementRef<HTMLInputElement> | undefined;
 // regulatorAutoComplete = new FormControl('');

  constructor(private userService: UserManagementService, public commonService: CommonService) {
    this.pubTypeList = new RegulatorPubTypeModel();
    this.myInnerHeight = window.innerHeight - 150;
    this.regulatorArray = [];
    this.pubArray = [];
    this.allRegulators = [];
    this.regulators = [];
    this.jurisdictions = [];
    this.jurisRegulator = [];
    this.toastModel = new ToastViewModel();
    this.updatedPubType = [];
  }

  ngOnInit(): void {
    this.fetchJurisdictions();
  }

  tabChanged(event: any): void {
    if (event.index === 1) {
      if(this.selectedJurisId > 1){
        this.selectedJurisIdForPubType = this.selectedJurisId;
      }
      else{
        this.selectedJurisIdForPubType =this.jurisdictions.length>0? this.jurisdictions[0].id:0;
      }
      this.fetchJurisRegulator();
    } else {
      if(this.selectedJurisIdForPubType > 1){
        this.selectedJurisId = this.selectedJurisIdForPubType;
      }
      else{
        this.selectedJurisId = this.jurisdictions.length>0? this.jurisdictions[0].id:0;
      }
      this.fetchJurisdictionsRegulator();
    }
  }

  // Jurisdiction
  fetchJurisdictions(): void {
    this.isLoading = true;
    this.userService.getUserJurisdictions().subscribe((data: ItemIdModel[]) => {
      this.jurisdictions = data;
      this.isLoading = false;
      if (this. jurisdictions && this.jurisdictions.length > 0) {
        this.selectedJurisId = this.jurisdictions[0].id;
        this.fetchJurisdictionsRegulator();
      }
    });
  }

  fetchJurisdictionsRegulator(): void {
    this.regulatorArray = [];
    this.userService.getJurisdictionsRegulator(this.selectedJurisId).subscribe((data: ParentChildItemModel[]) => {
      this.jurisRegulator = data;
      // this.jurisRegulator.forEach(element => {
      //   this.regulatorArray.push(element.itemId);
      // });
      this.regulatorArray= this.jurisRegulator.map(item => item.itemId);
      this.fetchRegulators();
    });
  }

  regulatorFilter(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase();
    if(filterValue){
      this.searchedRegulators = this.jurisRegulator.filter(o => o.itemTitle.toLowerCase().includes(filterValue));
    }
    else{
      this.searchedRegulators = this.jurisRegulator;
    }
  }
  fetchJurisRegulator(): void {
    this.searchRegulatorId = 0;
    this.regulatorArray = [];
    this.userService.getJurisdictionsRegulator(this.selectedJurisIdForPubType).subscribe((data: ParentChildItemModel[]) => {
      this.jurisRegulator = data;
      this.searchedRegulators = this.jurisRegulator;
     //this.regulatorAutoSelect({ option: { value: this.searchedRegulators.length > 0 ? this.searchedRegulators[0].itemId.toString() : '' } });
      // this.regulatorAutocompleteCntrl.valueChanges.subscribe((term: any) => {
      //   this.searchedRegulators = term ? this.filterRegulators(term) : this.jurisRegulator;
      // });
      if (data && data.length > 0) {
        this.searchRegulatorId = this.jurisRegulator[0].itemId;
        this.fetchPubTypes();
      }
    });
  }

  fetchRegulators(): void {
    this.userService.getRegulators().subscribe((data: RegulatorMaster[]) => {
      this.allRegulators = data;
      this.regulators = data;
    });
  }

  onEnterKeySearch(event: any): void {
    if (event.keyCode === 13) {
      this.searchRegulator();
    }
    if (event.keyCode === 8 && !this.searchRegText) {
      this.regulators = this.regulators;
    }
  }

  onEnterPubSearch(event: any): void {
    if (event.keyCode === 13) {
      this.searchPub();
    }
  }
 // Changes by Amit Madahar - 31 May 2023 - added geography and metadata in search
 searchRegulator(): void {
  this.regulators = this.allRegulators.filter(a =>
    a.regulator.toLowerCase().trim().includes(this.searchRegText.toLowerCase().trim()) ||
    a.geography.toLowerCase().trim().includes(this.searchRegText.toLowerCase().trim()) ||
    (a.metaData && this.isValidJson(a.metaData) && JSON.parse(a.metaData).filter((b: { PubType: string; }) =>
      b.PubType && b.PubType.toLowerCase().trim().includes(this.searchRegText.toLowerCase().trim())
    ).length > 0)
  );
}

 isValidJson(jsonString: string): boolean {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
}
  // searchRegulator(): void {
  //   this.regulators = this.allRegulators.filter(a => a.regulator.toLowerCase().trim()
  //     .includes(this.searchRegText.toLowerCase().trim()));
  // }
  searchPub(): void {
    this.pubTypeList.pubType = this.allPub.filter((a: { title: string; }) => a.title.toLowerCase()
      .includes(this.searchPubText.toLowerCase()));
  }

  selectAllItem(event: boolean): void {
    if (event) {
      if(this.regulatorArray.length < 1){
        this.regulators.forEach(item => {
          this.regulatorArray.push(item.id);
        });
      }
      else{
        this.regulators.forEach(item => {
          this.regulatorArray.push(item.id);
        });
      }
    } else {
      this.regulatorArray = [];
    }
  }

  selectAllPubItem(event: boolean): void {
    this.pubTypeList.pubType.forEach(item => {
      if(event == true){item.isActive = false;}
      if(event == false){item.isActive = true;}
      //item.isActive = event;
      this.selectPubType(item.title, event, item.updatesDB_Id)
    });
  }
  getUpdatedPubTypeLen() {
    let len = 0;
    this.pubTypeList.pubType.forEach(item => {
      if (!item.isActive)
        len++;
    });
    return len;
  }

  selectRegulators(id: number, event: boolean): void {
    if (event) {
      this.regulatorArray.push(id);
    } else {
      const index = this.regulatorArray.indexOf(id);
      if (index > -1) {
        this.regulatorArray.splice(index, 1);
      }
    }
  }

  checkJurisRegulator(regulatorId: number): boolean {
    const index = this.regulatorArray.findIndex(a => a === regulatorId);
    return index >= 0 ? true : false;
  }

  saveJurisdictionRegulator(): void {
    this.isLoader = true;
    let userDivision = localStorage.getItem("selectedDivisionName");
    const obj = new DownloadReportModel();
    obj.id = this.selectedJurisId;
    obj.idList = this.regulatorArray;
    this.userService.saveJurisdictionsRegulator(obj, userDivision).subscribe((data: any) => {
      this.isLoader = false;
    });
  }

  regulatorDisplayFn(value?: number) {
    return value ? this.jurisRegulator.find(_ => _.itemId === value)?.itemTitle : undefined;
  }
  filterRegulators(search: string): any {
    if (typeof search === 'number')
      return undefined;
    return this.jurisRegulator.filter(option =>
      option.itemTitle.toLowerCase().includes(search.toLowerCase())
    );
  }
  regulatorAutoSelect(event: MatAutocompleteSelectedEvent) {
    this.searchRegulatorId = event.option.value;
    this.fetchPubTypes();
  }
  fetchPubTypes(): void {
    this.isLoadingBar = true;
    this.pubArray = [];
    this.userService.getPubTypes(this.selectedJurisIdForPubType, this.searchRegulatorId).subscribe((data: RegulatorPubTypeModel) => {
      this.isLoadingBar = false;
      this.pubTypeList = data;
      this.allPub = data.pubType;
      this.regulatorArray = this.allPub;
    });
  }

  selectPubType(pubType: string, status: boolean, updatesDB_Id: number): void {
    if (this.searchRegulatorId === 0) {
      this.toastModel.Type = 'warning';
      this.toastModel.Title = 'Warning';
      this.toastModel.Message = 'Please select Regulator';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 4000);
    } else {
      const obj = new UpdatePubType();
      obj.regulatorId = this.searchRegulatorId;
      obj.pubType = pubType;
      if(status == false){
        obj.isActive = true;
      }
      else if(status == true){
        obj.isActive = false;
      }
      obj.jurisdictionId = this.selectedJurisIdForPubType;
      obj.updatesDB_Id = updatesDB_Id
      const index = this.updatedPubType.findIndex(a => a.pubType === pubType);
      if (index > -1) {
        this.updatedPubType.splice(index, 1);
      }
      this.updatedPubType.push(obj);
    }
  }

  updatePubType(): void {
    if (this.updatedPubType.length === 0) {
      this.toastModel.Type = 'warning';
      this.toastModel.Title = 'Warning';
      this.toastModel.Message = 'Please select at least one';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 4000);
    } else {
      this.isLoadingBar = true;
      let userDivision = localStorage.getItem("selectedDivisionName");
      if (this.jurisdictions && this.jurisdictions.length > 0) {
        let filterJurisdictionArray=this.jurisdictions.find(a => a.id == this.selectedJurisIdForPubType);
        if(filterJurisdictionArray){
          userDivision = filterJurisdictionArray.name;
        }
      }
      let userRegulator = '';
      if (this.searchedRegulators && this.searchedRegulators.length > 0) {
        let filterRegulatorArray=this.searchedRegulators.find(a => a.itemId == this.searchRegulatorId);
        if(filterRegulatorArray){
          userRegulator = filterRegulatorArray.itemTitle;
        }
      }
      this.userService.updatePubType(this.updatedPubType,userDivision,userRegulator).subscribe(() => {
        this.fetchPubTypes();
      });
    }
  }
  downloadUserRegulator(): any {
    // this.isLoading = true;
    this.isExportLoader = true;
    const str = Array.prototype.map.call(this.jurisdictions, function (item) { return item.id; }).join(",");

    this.userService.exportUserRegulatorReport(str).subscribe((data: any) => {
      //this.isLoading = false;
      const a = document.createElement('a'),
        fileURL = URL.createObjectURL(data);
      a.href = fileURL;
      a.download = `UserRegulatorInfo.xlsx`;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
      this.isExportLoader = false;
    },
      (error: HttpErrorResponse) => {
        //this.isLoading = false;
        //Logger.log(this.constructor.name, error.error);
      })
    // this.userManagementService.exportUserReport().subscribe(
    //   (data: any) => {
    //     this.isLoading = false;
    //     const a = document.createElement('a'),
    //       fileURL = URL.createObjectURL(data);
    //     a.href = fileURL;
    //     a.download = `UserInfo.xlsx`;
    //     window.document.body.appendChild(a);
    //     a.click();
    //     window.document.body.removeChild(a);
    //   },
    //   (error: HttpErrorResponse) => {
    //     this.isLoading = false;
    //     //Logger.log(this.constructor.name, error.error);
    //   }
    // );
  }
}
